<div class="blogs-container">
  <div class="header">
    <div class="header-img-section">
      <img src="../../../assets/images/icon 09.jpg" alt="" />
    </div>
    <div class="title">
      <div class="main-title">Blogs</div>
      <div class="sub-title">
        Our take on all things that matter
      </div>
    </div>
    <div class="flex-spacer"></div>
    <div class="add-btn btn" *ngIf="authService.isAdmin" (click)="onClickAdd()">
      <i class="fa-solid fa-plus"></i>
    </div>
  </div>
  <div class="blogs">
    <a  class="blog" *ngFor="let blog of blogs" (click)="onClickBlog(blog)" target="_blank">
      <div class="name">{{blog.title}}</div>
      <div class="date">{{ blog.createdDate | date: "dd/MM/yyyy" }}</div>
      <div class="description">
        {{blog.description}}
      </div>
      <div class="img-section img1">
        <img src="../../assets/images/icon 03.png" alt="" />
      </div>
    </a>
  </div>
  <div class="more-btn btn" (click)="onClickMore()">
    <i class="fa-solid fa-angle-right"></i>
  </div>
  <div class="main-img-section">
    <img src="../../../assets/images/icon 08 (1).png" alt="" />
  </div>
</div>
